<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="模块名称">
                <a-input v-model="queryParam.moduleName" placeholder="请输入模块名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="模块类型">
                <a-select
                  placeholder="请选择模块类型"
                  v-model="queryParam.moduleSystemType"
                  style="width: 100%"
                  allow-clear
                >
                  <a-select-option :value="0">平台模块</a-select-option>
                  <a-select-option :value="1">系统内置</a-select-option>
                  <a-select-option :value="2">其它模块</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select placeholder="请选择状态" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :value="0">禁用</a-select-option>
                  <a-select-option :value="1">正常</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24" v-if="advanced">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="value"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 18" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd" v-hasPermi="['5d3d56e79ff70ad30fba2c3a13ac641dc:0:c']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="danger"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['5d3d56e79ff70ad30fba2c3a13ac641dr:0:r']"
        >
          <a-icon type="delete" />删除
        </a-button>
      </div>

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
      >
        <span slot="moduleSystemType" slot-scope="text">
          <a-tag :color="getModuleTypeColor(text)">
            {{ getModuleTypeText(text) }}
          </a-tag>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmHandleStatus(record)"
            @cancel="cancelHandleStatus(record)"
          >
            <span slot="title">
              确认<b>{{ record.status === 1 ? '禁用' : '启用' }}</b
              >吗?
            </span>
            <a-switch
              v-hasPermi="['5d3d56e79ff70ad30fba2c3a13ac641dd:0:s']"
              checked-children="启用"
              un-checked-children="禁用"
              :checked="record.status == 1"
            />
          </a-popconfirm>
        </span>
        <span slot="createTime" slot-scope="text">
          <a-tooltip :title="text || '--'">
            <span class="text-ellipsis">{{ text || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleModuleMenu(record)" v-hasPermi="['ed423216bc32f1207aa8300b53bea16db:0:b']">模块菜单</a>
          <a-divider
            type="vertical"
            v-hasPermi="[
              'ed423216bc32f1207aa8300b53bea16db:0:b',
              '5d3d56e79ff70ad30fba2c3a13ac641dq:0:q',
              '5d3d56e79ff70ad30fba2c3a13ac641dd:0:d',
              '5d3d56e79ff70ad30fba2c3a13ac641dr:0:r',
            ]"
          />
          <a-dropdown
            v-hasPermi="[
              '5d3d56e79ff70ad30fba2c3a13ac641dq:0:q',
              '5d3d56e79ff70ad30fba2c3a13ac641dd:0:d',
              '5d3d56e79ff70ad30fba2c3a13ac641dr:0:r',
            ]"
          >
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['5d3d56e79ff70ad30fba2c3a13ac641dq:0:q']">
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item v-if="record.status == 0" v-hasPermi="['5d3d56e79ff70ad30fba2c3a13ac641dd:0:d']">
                <a @click="handleEdit(record)">修改</a>
              </a-menu-item>
              <a-menu-item v-if="record.status == 0" v-hasPermi="['5d3d56e79ff70ad30fba2c3a13ac641dr:0:r']">
                <a @click="handleDelete(record)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <create-form ref="createFormDrawer" @ok="getList" />
    <detail-drawer ref="detailDrawer" />
    <module-menu-drawer ref="moduleMenuDrawer" @ok="getList" />
  </page-header-wrapper>
</template>

<script>
import { pageModule, deleteModule, disableModule } from '@/api/system/module'
import moment from 'moment'
import CreateForm from './modules/CreateForm.vue'
import DetailDrawer from './modules/DetailDrawer.vue'
import ModuleMenuDrawer from './modules/ModuleMenuDrawer.vue'

export default {
  name: 'FunctionModule',
  components: {
    CreateForm,
    DetailDrawer,
    ModuleMenuDrawer,
  },
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      multiple: true,
      ids: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        moduleName: undefined,
        moduleSystemType: undefined,
        status: undefined,
        description: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
      },
      total: 0,
      value: [],
      advanced: false,
      loading: false,
      tableSize: 'default',
      columns: [
        {
          title: '模块名称',
          dataIndex: 'moduleName',
          key: 'moduleName',
          align: 'center',
          width: '15%',
        },
        {
          title: '模块类型',
          dataIndex: 'moduleSystemType',
          key: 'moduleSystemType',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'moduleSystemType' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          align: 'center',
          width: 80,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '模块描述',
          dataIndex: 'description',
          key: 'description',
          align: 'center',
          scopedSlots: { customRender: 'description' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          width: 160,
        },
      ],
    }
  },
  methods: {
    getModuleTypeText(type) {
      const map = {
        0: '平台模块',
        1: '系统内置',
        2: '其它模块',
      }
      return map[type] || '未知'
    },
    getModuleTypeColor(type) {
      const map = {
        0: 'blue',
        1: 'green',
        2: 'orange',
      }
      return map[type] || 'default'
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        moduleName: undefined,
        moduleSystemType: undefined,
        status: undefined,
        description: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    getList() {
      this.loading = true
      const params = { ...this.queryParam }
      if (this.value && this.value.length === 2) {
        params.createBeginTime = moment(this.value[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        params.createEndTime = moment(this.value[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      pageModule(params)
        .then((res) => {
          this.list = res.data.records || []
          this.total = res.data.total || 0
        })
        .catch(() => {
          this.$message.error('获取功能模块列表失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    onChangeTime(e) {
      if (e && e.length === 2) {
        this.value = e
      } else {
        this.value = []
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    handleAdd() {
      this.$refs.createFormDrawer.init()
    },
    handleDetail(record) {
      this.$refs.detailDrawer.show(record)
    },
    handleEdit(record) {
      this.$refs.createFormDrawer.init(record)
    },
    handleModuleMenu(record) {
      this.$refs.moduleMenuDrawer.show(record)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.multiple = !selectedRowKeys.length
    },
    handleDelete(row) {
      var that = this
      let ids = []
      if (row && row.id) {
        ids = [{ id: row.id }]
      } else {
        if (!this.ids || this.ids.length === 0) {
          this.$message.warning('请选择要删除的数据', 3)
          return
        }
        this.ids.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: row && row.id ? '是否确认删除此数据?' : `是否确认删除选中的 ${ids.length} 条数据?`,
        onOk() {
          return deleteModule(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    confirmHandleStatus(record) {
      disableModule({ id: record.id }).then(() => {
        this.$message.success('操作成功')
        this.getList()
      })
    },
    cancelHandleStatus() {},
  },
  created() {
    this.getList()
  },
}
</script>

<style lang="less" scoped>
.text-ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
